import { render, staticRenderFns } from "./FormDeleted.vue?vue&type=template&id=10646892&scoped=true"
import script from "./FormDeleted.vue?vue&type=script&lang=js"
export * from "./FormDeleted.vue?vue&type=script&lang=js"
import style0 from "./FormDeleted.vue?vue&type=style&index=0&id=10646892&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10646892",
  null
  
)

export default component.exports